import { getInitialPropertiesForRequest } from '@pages/Parameters/helpers/getPropertiesForUpdate'

import { TextParams } from '@components/TextSettings'

import { MODEL_TYPE, PARAMETER_KEY, PARAMETER_STATE } from '@constants'

export const getParametersForCreation = (
  columnHeaderCode: string,
  columnTextCode: string,
  columnHeaderData?: TextParams,
  columnTextData?: TextParams,
  type?: MODEL_TYPE
) => {
  return [
    {
      paramKey: PARAMETER_KEY.HEADER,
      param: {
        code: columnHeaderCode,
        title: 'Column Header Styles',
        type: 'variable',
        properties:
          columnHeaderData && type !== MODEL_TYPE.VIEW
            ? getInitialPropertiesForRequest({
                textData: columnHeaderData,
              })
            : undefined,
        propertiesType: 'string',
        description: '',
        state: PARAMETER_STATE.ACTIVE,
      },
    },
    {
      paramKey: PARAMETER_KEY.TEXT,
      param: {
        code: columnTextCode,
        title: 'Column Text Styles',
        type: 'variable',
        properties:
          columnTextData && type !== MODEL_TYPE.VIEW
            ? getInitialPropertiesForRequest({
                textData: columnTextData,
              })
            : undefined,
        propertiesType: 'string',
        description: '',
        state: PARAMETER_STATE.ACTIVE,
      },
    },
  ]
}
